export const KPI_TITLES = {
	totalSpend: 'Total Spend',
	poCount: 'PO Count',
	skuCount: 'SKU Count',
	supplierCount: 'Supplier Count',
	originCountries: 'Origin Countries',
	destination: 'Destinations',
	totalBuyers: 'Total Buyers',
};
